"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileBreadcrumb = void 0;
require("../css/mobile-breadcrumb.scss");
var GenericFunctions = require("./generic-functions");
var IframeComms = require("./frame-comms/iframe-comms");
var BreadCrumbBuilder = require("./breadcrumb-builder");
var MobileBreadcrumb = /** @class */ (function () {
    function MobileBreadcrumb() {
    }
    MobileBreadcrumb.init = function () {
        document.getElementById('mobile-breadcrumb').innerHTML = BreadCrumbBuilder.generate(window.location.href, window.appData.categories, window.appData.subCategories);
        var homeButton = document.getElementById('clickable-home-button');
        var addButton = document.getElementById('clickable-add-more-button');
        var subCategoryButton = document.getElementById('breadcrumb-subcategory');
        var categoryButton = document.getElementById('breadcrumb-category');
        homeButton.addEventListener('click', function () {
            window.location.href = window.location.origin.concat(window.location.pathname.substring(0, GenericFunctions.nthIndex(window.location.pathname, "/", 3)));
        });
        categoryButton.setAttribute('href', window.location.href.split('?')[0]);
        if (addButton) {
            addButton.addEventListener('click', GenericFunctions.handleClickCloseModal);
        }
        if (subCategoryButton) {
            subCategoryButton.addEventListener('click', GenericFunctions.handleClickCloseModal);
        }
        $(".expand-subcategory").click(function (e) {
            setTimeout(function () {
                IframeComms.propagateHeightAlt(false);
            }, 500);
        });
    };
    return MobileBreadcrumb;
}());
exports.MobileBreadcrumb = MobileBreadcrumb;
